export const emptySetTitle = 'No edited videos';
export const emptySetDescription =
	'Uploaded files will be automatically be converted to 480p, 720p, and 1080p versions, then added to this services listing and delivered to the client.';
